export default "__VITE_ASSET__h_tNWQhG__"